module.exports = __webpack_public_path__ + "media/images/logo-35fba1df89fad7499f41af2ff004cbce.svg";